import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getOrganisationDataWithId } from '../../utils/api/organisationAPI';
import { Icon } from '@iconify/react/dist/iconify.js';
import { getUsersFromOrganisationId } from '../../utils/api/userAPI';
import { convertToIndianTimeZone } from '../../utils/utils';
import { getOrganisationIntegrations } from '../../utils/api/integrationAPI';
import { ShimmerLoader } from './ShimmerLoader';

const OrganiastionViewTab = () => {
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const [data, setData] = useState({});
    // OrganisationUser variables start
    const [orgUser, setOrgUser] = useState([]);
    const [orgUserPage, setOrgUserPage] = useState(1);

    const [orgUserTotalRecords, setOrgUserTotalRecords] = useState();
    const [orgUserNumberOfResult, setOrgUserNumberOfResult] = useState(10);
    const [orgUserTotalPages, setOrgUserTotalPages] = useState(1);

    // OrganisationUser variables end

    // Organisation Integration start

    const [orgIntegration, setOrgIntegration] = useState([])


    // Organisation Integration end

    useEffect(() => {
        //  integration API function
        getOrganisationIntegrations(id, )
            .then(data => {
                setOrgIntegration(data["integrations"]);
                
            })
            .catch(err => console.error("Error fetching integrations:", err));
    }, [id]);


    useEffect(() => {
        getUsersFromOrganisationId(id, orgUserPage, orgUserNumberOfResult)
            .then(data => {
               
                setOrgUserTotalRecords(data["total"]);
                setOrgUser(data["users"]);


                const total = Math.ceil(data["total"] / orgUserNumberOfResult);
                setOrgUserTotalPages(total > 0 ? total : 1);
            })
            .catch(e => console.error(e));
    }, [id, orgUserPage, orgUserNumberOfResult]);



    useEffect(() => {
        try {
            setLoading(true);
            getOrganisationDataWithId(id).then(data => setData(data["organization"]))
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [id]);




    if (loading) {
        return (
            <div className="col" style={{
                height: "80vh"
            }}>
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-24 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                        <h6 className="text-lg mb-0">Organisation Details</h6>
                    </div>
                    <ShimmerLoader />
                </div>
            </div>
        );
    }



    return (
        <div className="col" style={{
            height: 'auto'
        }}>
            <div className="card p-0 overflow-hidden position-relative radius-12 ">
                <div className="card-header py-24 px-24 bg-base border border-end-0 border-start-0 border-top-0">
                    <h6 className="text-lg mb-0">Organisation Details</h6>
                </div>
                <div className="card-body p-24 pt-10">
                    <ul
                        className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-16"
                        id="pills-tab"
                        role="tablist"
                    >
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link active px-16 py-10"
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                type="button"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                            >
                                Organisation Details
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10"
                                id="pills-details-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-details"
                                type="button"
                                role="tab"
                                aria-controls="pills-details"
                                aria-selected="false"
                            >
                                Organisation Users
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10"
                                id="pills-details-integrations-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-details-integrations"
                                type="button"
                                role="tab"
                                aria-controls="pills-details-integrations"
                                aria-selected="false"
                            >
                                Organisation Integrations
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        {/* Organisation Details start*/}
                        <div
                            className="tab-pane fade show active"
                            id="pills-home"
                            role="tabpanel"
                            aria-labelledby="pills-home-tab"
                            tabIndex={0}
                        >
                            <div style={{
                                padding: '30px',
                                fontFamily: 'Arial, sans-serif',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                width: '80%',
                                margin: '20px auto'
                            }}>
                                {/* <h6 style={{
                                    fontSize: '22px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    marginBottom: '20px'
                                }}>Detail Summary</h6> */}
                                <div className='row' style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>


                                    <div style={{ flex: '1 1 65%', minWidth: '250px' }}>
                                        <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '12px', marginBottom: '20px' }}>
                                            <div style={{ marginBottom: '16px' }}>
                                                <strong style={{ fontWeight: '600' }}>Name:</strong> <span>{data.name}</span>
                                            </div>
                                            <div style={{ marginBottom: '16px' }}>
                                                <strong style={{ fontWeight: '600' }}>Address: </strong>
                                                <span>{data.addressLine1}, {data.addressLine2 ? `${data.addressLine2},` : ""} {data.city}, {data.state}, {data.country} - {data.pincode}</span>
                                            </div>
                                            <div style={{ marginBottom: '16px' }}>
                                                <strong style={{ fontWeight: '600' }}>Entity Type:</strong> <span>{data.entity_type}</span>
                                            </div>
                                            <div style={{ marginBottom: '16px' }}>
                                                <strong style={{ fontWeight: '600' }}>Sector:</strong> <span>{data.sector}</span>
                                            </div>
                                            <div style={{ marginBottom: '16px' }}>
                                                <strong style={{ fontWeight: '600' }}>Number of Employees:</strong> <span>{data.noOfEmployees}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '12px', marginBottom: '20px' }}>

                                    <div style={{ marginBottom: '16px' }}>
                                        <strong style={{ fontWeight: '600' }}>Subscription Status:</strong> <span>{data.isSubscribed ? 'Subscribed' : 'Not Subscribed'}</span>
                                    </div>
                                    <div style={{ marginBottom: '16px' }}>
                                        <strong style={{ fontWeight: '600' }}>Minutes Used:</strong> <span>{data.minutesUsed}</span>
                                    </div>
                                    <div style={{ marginBottom: '16px' }}>
                                        <strong style={{ fontWeight: '600' }}>Status:</strong> <span>{data.status ? 'Active' : 'Inactive'}</span>
                                    </div>
                                </div>



                                {data.gstOrPanNumber && (
                                    <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '12px', marginBottom: '20px' }}>
                                        <strong style={{ fontSize: '16px', color: '#555' }}>Tax Information</strong>
                                        <div style={{ marginBottom: '16px' }}>
                                            <strong style={{ fontWeight: '600' }}>GST or PAN Number:</strong> <span>{data.gstOrPanNumber}</span>
                                        </div>
                                    </div>
                                )}

                                <div style={{ marginBottom: '12px', alignItems: 'column' }}>
                                    <strong style={{ fontWeight: '600' }}>ID:</strong> <span>{data.id}</span>

                                </div>
                                <strong style={{ fontWeight: '600' }}>createdAt:</strong> <span>{data.createdAt}</span>
                            </div>
                        </div>
                        {/* Organisation Details end*/}
                        {/* Organisation users start*/}
                        <div
                            className="tab-pane fade"
                            id="pills-details"
                            role="tabpanel"
                            aria-labelledby="pills-details-tab"
                            tabIndex={0}
                        >
                            {/* This is for organisations user  below will help us to show table for the users inside the organisation */}
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <div className="d-flex align-items-center gap-10">ID</div>
                                            </th>
                                            <th scope="col">Created At</th>
                                            <th scope="col">Full Name</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Phone Number</th>
                                            <th scope="col" className="text-center">Status</th>
                                           {/*  <th scope="col" className="text-center">Action</th> */}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {orgUser.map((item) => (
                                            <tr key={item.id}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-10">
                                                        {item.id.length > 7 ? `${item.id.slice(0, 6)}...` : item.id}
                                                    </div>
                                                </td>
                                                <td>{convertToIndianTimeZone(item.createdAt)}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                {item.displayName}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {item.email}
                                                    </span>
                                                </td>
                                                <td>{item.phone}</td>
                                                <td className="text-center">
                                                    {item.status ? (
                                                        <span className="badge text-sm fw-semibold text-success-600 bg-success-100 px-20 py-9 radius-4 text-white">
                                                            Active
                                                        </span>
                                                    ) : (
                                                        <span className="badge text-sm fw-semibold text-danger-600 bg-danger-100 px-20 py-9 radius-4 text-white">
                                                            InActive
                                                        </span>
                                                    )}
                                                </td>
                                               {/*  <td className="text-center">
                                                    <div className="d-flex align-items-center gap-10 justify-content-center">
                                                        <button
                                                            type="button"
                                                            onClick={() => { }}
                                                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                        >
                                                            <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => { }}
                                                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                        >
                                                            <Icon icon="lucide:edit" className="menu-icon" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => { }}
                                                            className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                        >
                                                            <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                        </button>
                                                    </div>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* Empty State */}
                                {orgUser.length === 0 && (
                                    <div
                                        className="d-flex flex-column justify-content-center align-items-center"
                                        style={{ height: '52vh' }}
                                    >
                                        <p className="text-secondary-light text-md mb-16">No users found</p>
                                        <button
                                            type="button"
                                            className="btn btn-info-600 radius-8 px-20 py-11"
                                            style={{ minWidth: '180px' }}
                                        >
                                            Add New User
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                                <span>Showing 1 to {orgUserNumberOfResult} of {orgUserTotalRecords} entries</span>
                                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">

                                    {/* Previous button */}
                                    <li className={`orgUserPage-item ${orgUserPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className="orgUserPage-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                            onClick={() => setOrgUserPage((prev) => Math.max(prev - 1, 1))}
                                        >
                                            <Icon icon="ep:d-arrow-left" />
                                        </button>
                                    </li>

                                    {/* orgUserPage numbers */}
                                    {Array.from({ length: orgUserTotalPages }, (_, i) => (
                                        <li className="orgUserPage-item" key={i}>
                                            <button
                                                className={`orgUserPage-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${orgUserPage === i + 1
                                                    ? 'bg-primary-600 text-white'
                                                    : 'bg-neutral-200 text-secondary-light'
                                                    }`}
                                                onClick={() => setOrgUserPage(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}

                                    {/* Next button */}
                                    <li className={`orgUserPage-item ${orgUserPage === orgUserTotalPages ? 'disabled' : ''}`}>
                                        <button
                                            className="orgUserPage-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                                            onClick={() => setOrgUserPage((prev) => Math.min(prev + 1, orgUserTotalPages))}
                                        >
                                            <Icon icon="ep:d-arrow-right" />
                                        </button>
                                    </li>
                                </ul>
                            </div>



                        </div>
                        {/*Organisation user ends */}
                        {/* Organisation Integration start */}
                        <div
                            className="tab-pane fade"
                            id="pills-details-integrations"
                            role="tabpanel"
                            aria-labelledby="pills-details-integrations-tab"
                            tabIndex={0}
                        >
                            {/* This is for organisations user  below will help us to show table for the users inside the organisation */}
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <div className="d-flex align-items-center gap-10">ID</div>
                                            </th>
                                            <th scope="col">Created At</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">API Key</th>
                                            <th scope="col">Type</th>
                                            <th scope="col" className="text-center">Status</th>
                                            {/* <th scope="col" className="text-center">Action</th> */}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {orgIntegration.map((item) => (
                                            <tr key={item.id}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-10">
                                                        {item.id.length > 7 ? `${item.id.slice(0, 6)}...` : item.id}
                                                    </div>
                                                </td>
                                                <td>{convertToIndianTimeZone(item.createdAt)}</td>
                                                <td>{item.name}</td>
                                                <td>{"****" + item["api_key"].slice(0, 4) + "****" +item["api_key"].slice(-4) }</td>
                                                <td>{item.type}</td>
                                                <td className="text-center">
                                                    {item.status ? (
                                                        <span className="badge text-sm fw-semibold text-success-600 bg-success-100 px-20 py-9 radius-4 text-white">
                                                            Active
                                                        </span>
                                                    ) : (
                                                        <span className="badge text-sm fw-semibold text-danger-600 bg-danger-100 px-20 py-9 radius-4 text-white">
                                                            InActive
                                                        </span>
                                                    )}
                                                </td>
                                               {/*  <td className="text-center">
                                                    <div className="d-flex align-items-center gap-10 justify-content-center">
                                                        <button type="button" className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle">
                                                            <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                        </button>
                                                        <button type="button" className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle">
                                                            <Icon icon="lucide:edit" className="menu-icon" />
                                                        </button>
                                                        <button type="button" className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle">
                                                            <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                        </button>
                                                    </div>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>

                                {/* Empty State */}
                                {orgIntegration.length === 0 && (
                                    <div
                                        className="d-flex flex-column justify-content-center align-items-center"
                                        style={{ height: '52vh' }}
                                    >
                                        <p className="text-secondary-light text-md mb-16">No integrations found</p>
                                        {/* <button
                                            type="button"
                                            className="btn btn-info-600 radius-8 px-20 py-11"
                                            style={{ minWidth: '180px' }}
                                        >
                                            Add New Integration
                                        </button> */}
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* Organisation Integration end */}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default OrganiastionViewTab;
